import anime from 'animejs'
import { onAdd, onRemove } from '../utils/class-list'
import { onSelect } from '../utils/dom'
import PATHS from './anime-path'
import {
  SEL_SHADOW_HOTEL,
  SEL_HOTEL,
  SEL_SHADOW_BOX,
  SEL_BOX,
  SEL_SHADOW_BELT,
  SEL_BELT,
  SEL_LEVER,
  SEL_BTN_ON,
  SEL_BTN_OFF,
  SEL_MEETING_GROUP_1,
  SEL_CAKE_1,
  SEL_COUPLE_WEDDINGS_1,
  SEL_MEETING_GROUP_2,
  SEL_CAKE_2,
  SEL_COUPLE_WEDDINGS_2,
  SEL_MEETING_GROUP_3,
  SEL_COUPLE_WEDDINGS_3,
  SEL_CAKE_3,
} from './anime-selectors'

const PROPS_ANIME = {
  loop: false,
  autoplay: false,
}

const OBJ_ANIMATIONS = {}

if (onSelect('#_soyh5qm8e')) {
  const {
    PATH_MEET_1: P_MEET_1,
    PATH_CAKE_1: P_CAKE_1,
    PATH_WEDD_1: P_WEDD_1,
    PATH_MEET_2: P_MEET_2,
    PATH_CAKE_2: P_CAKE_2,
    PATH_WEDD_2: P_WEDD_2,
    PATH_MEET_3: P_MEET_3,
    PATH_WEDD_3: P_WEDD_3,
    PATH_CAKE_3: P_CAKE_3,
  } = PATHS

  OBJ_ANIMATIONS.ANI_BELT = anime
    .timeline({
      ...PROPS_ANIME,
      easing: 'easeInOutSine',
      duration: 820,
      delay: anime.stagger(80),
      update: function (anim) {
        if (anim.progress >= 70) {
          onRemove(document.body, 'overflow-element')
        }
      },
    })
    .add({ targets: SEL_SHADOW_BOX, opacity: 1, translateY: [-80, 8, -16, 0] })
    .add({ targets: SEL_BOX, opacity: [0, 0.6, 1], translateY: [-80, 8, -16, 0] }, '-=540')
    .add({ targets: SEL_SHADOW_BELT, opacity: 1, translateY: [-80, 8, -12, 0] }, '-=580')
    .add({ targets: SEL_BELT, opacity: [0, 0.6, 1], translateY: [-80, 8, -12, 0] }, '-=640')
    .add(
      {
        targets: SEL_LEVER,
        opacity: {
          value: 1,
          duration: 400,
        },
        translateY: 0,
      },
      '-=800'
    )
    .add({ targets: SEL_BTN_ON, opacity: 0.4 }, '-=300')
    .add({ targets: SEL_BTN_OFF, opacity: 1 }, '-=400')
    .add({ targets: SEL_LEVER, duration: 600, translateY: [0, '-128%'] }, '-=1180')
    .add({ targets: SEL_BTN_OFF, opacity: 0.4 }, '-=200')
    .add({ targets: SEL_BTN_ON, opacity: 1 }, '-=400')
    .add({ targets: SEL_MEETING_GROUP_1, duration: 500, opacity: 1, top: [-80, -58] }, '-=1800')

  OBJ_ANIMATIONS.ANI_PICTURE_1 = anime
    .timeline({
      ...PROPS_ANIME,
      easing: 'easeOutQuad',
      duration: 5000,
    })
    .add({ targets: SEL_MEETING_GROUP_1, translateX: P_MEET_1('x'), translateY: P_MEET_1('y') })
    .add({ targets: SEL_CAKE_1, translateX: P_CAKE_1('x'), translateY: P_CAKE_1('y') }, 1000)
    .add({ targets: SEL_COUPLE_WEDDINGS_1, translateX: P_WEDD_1('x'), translateY: P_WEDD_1('y') }, 2000)

  OBJ_ANIMATIONS.ANI_PICTURE_2 = anime
    .timeline({
      ...PROPS_ANIME,
      easing: 'easeOutQuad',
      duration: 5000,
    })
    .add({ targets: SEL_MEETING_GROUP_2, translateX: P_MEET_2('x'), translateY: P_MEET_2('y') })

  OBJ_ANIMATIONS.ANI_PICTURE_3 = anime
    .timeline({
      ...PROPS_ANIME,
      easing: 'easeOutQuad',
      duration: 6000,
    })
    .add({ targets: SEL_CAKE_2, translateX: P_CAKE_2('x'), translateY: P_CAKE_2('y') })
    .add({ targets: SEL_COUPLE_WEDDINGS_2, translateX: P_WEDD_2('x'), translateY: P_WEDD_2('y') }, '-=5400')

  OBJ_ANIMATIONS.ANI_PICTURE_4 = anime
    .timeline({
      ...PROPS_ANIME,
      easing: 'easeOutQuad',
      duration: 7000,
      update: function (anim) {
        if (anim.progress >= 32) {
          onAdd(SEL_SHADOW_HOTEL, 'icon--visible')
          onAdd(SEL_HOTEL, 'icon--visible')
        }
      },
    })
    .add({ targets: SEL_MEETING_GROUP_3, translateX: P_MEET_3('x'), translateY: P_MEET_3('y') })
    .add({ targets: SEL_COUPLE_WEDDINGS_3, translateX: P_WEDD_3('x'), translateY: P_WEDD_3('y') }, '-=5000')
    .add({ targets: SEL_CAKE_3, translateX: P_CAKE_3('x'), translateY: P_CAKE_3('y') }, '-=5800')

  OBJ_ANIMATIONS.ANI_PICTURE_ALL = anime
    .timeline({ ...PROPS_ANIME, easing: 'easeOutQuad', duration: 8000 })
    .add({ targets: SEL_MEETING_GROUP_1, translateX: P_MEET_1('x'), translateY: P_MEET_1('y') }, 0)
    .add({ targets: SEL_CAKE_1, translateX: P_CAKE_1('x'), translateY: P_CAKE_1('y') }, 10)
    .add({ targets: SEL_COUPLE_WEDDINGS_1, translateX: P_WEDD_1('x'), translateY: P_WEDD_1('y') }, 20)
    .add({ targets: SEL_MEETING_GROUP_2, translateX: P_MEET_2('x'), translateY: P_MEET_2('y') }, 50)
    .add({ targets: SEL_CAKE_2, translateX: P_CAKE_2('x'), translateY: P_CAKE_2('y') }, 70)
    .add({ targets: SEL_COUPLE_WEDDINGS_2, translateX: P_WEDD_2('x'), translateY: P_WEDD_2('y') }, 80)
    .add({ targets: SEL_MEETING_GROUP_3, translateX: P_MEET_3('x'), translateY: P_MEET_3('y') }, 100)
    .add({ targets: SEL_CAKE_3, translateX: P_CAKE_3('x'), translateY: P_CAKE_3('y') }, '-=8400')
    .add({ targets: SEL_COUPLE_WEDDINGS_3, translateX: P_WEDD_3('x'), translateY: P_WEDD_3('y') }, '-=8000')
}

export default OBJ_ANIMATIONS
